// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"B0-z","displaySixCardTiles":"C0-z"};